import { render, staticRenderFns } from "./eDocList.vue?vue&type=template&id=ec63aed4&scoped=true"
import script from "./eDocList.vue?vue&type=script&lang=js"
export * from "./eDocList.vue?vue&type=script&lang=js"
import style0 from "./eDocList.vue?vue&type=style&index=0&id=ec63aed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec63aed4",
  null
  
)

export default component.exports